import { defineComponent, ExtractPropTypes, InjectionKey } from 'vue';
import { createNamespaceBem, makeCustomProp, makeNumericProp, makeStringProp } from '@/utils';
import { useChildren } from '@vant/use';

export type StepItemsDirection = 'horizontal' | 'vertical';

const { name, bem } = createNamespaceBem('step-items');

const stepItemsProps = {
  active: makeNumericProp(0),
  disabled: makeCustomProp<boolean>(Boolean, false),
  tips: makeStringProp(''),
  direction: makeStringProp<StepItemsDirection>('vertical'),
};

export type StepItemsProps = ExtractPropTypes<typeof stepItemsProps>;

export type StepItemsProvide = {
  props: StepItemsProps;
  onClickStepItem: (index: number) => void;
};

export const STEP_ITEMS_KEY: InjectionKey<StepItemsProvide> = Symbol(name);

export default defineComponent({
  name,
  props: stepItemsProps,
  emits: ['clickStepItem'],
  setup(props, { emit, slots }) {
    const { linkChildren } = useChildren(STEP_ITEMS_KEY);
    const onClickStepItem = (ind: number) => emit('clickStepItem', ind);
    linkChildren({
      props,
      onClickStepItem,
    });

    return () => (
      <div class={bem([props.direction])}>
        {props.tips && <div class={bem('tips')}>{props.tips}</div>}
        {slots.default?.()}
      </div>
    );
  },
});
